import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/branches'
const API_URL_EMPLOYEE = process.env.VUE_APP_BASE_API_URL + '/api/v1/employee/branches'

class BranchApi {
  getList(page, size) {
    return axios.get(API_URL + '?actualPage=' + page + '&perPage=' + size, {
      headers: authHeader()
    })
  }

  employeeGetList(page, size) {
    return axios.get(API_URL_EMPLOYEE + '?actualPage=' + page + '&perPage=' + size, {
      headers: authHeader()
    })
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  createBranch(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }

  editBranch(uuid, data) {
    return axios.put(API_URL + '/' + uuid, data, { headers: authHeader() })
  }
}

export default new BranchApi()
